import { useLayoutEffect, type ReactNode } from "react";
import { createPortal } from "react-dom";
import { useShellChrome, useShellSlot } from "./ShellProvider";
import type { ShellSlot } from "./shellChrome";

interface ShellSlotContentProps {
  slot: ShellSlot;
  id: string;
  visibleDuringOverlay?: boolean;
  /** Portalled into the shell while the slot's host is mounted. */
  children?: ReactNode;
}

export function ShellSlotContent({ slot, id, visibleDuringOverlay = false, children }: ShellSlotContentProps) {
  const chrome = useShellChrome();
  const { ownerId, host } = useShellSlot(chrome, slot);

  useLayoutEffect(() => chrome.claim(slot, id, { visibleDuringOverlay }), [chrome, slot, id, visibleDuringOverlay]);

  if (!host || ownerId !== id) return null;
  return createPortal(children, host);
}
